const formatCurrency = (amount) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount || 0)

const formatCurrencyInput = (amount) =>
  new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(amount) || 0)

const parseCurrency = (amount) =>
  amount
    ? parseFloat(amount?.toString()?.replaceAll('.', '')?.replaceAll(',', '.'))
    : amount

export { formatCurrency, formatCurrencyInput, parseCurrency }
